export default __webpack_public_path__ + "static/media/banner-white.132ca765.png";